import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const OFFERS_API = 'https://3rey9w5wwi.execute-api.us-east-1.amazonaws.com/oryzadev/offer';
const TARGET_HOTEL = 'banana-bunks-mirissa';

const stylesheets = [
  'https://fonts.googleapis.com/css?family=Jost%3A100%2C200%2C300%2Cregular%2C500%2C600%2C700%2C800%2C900%2C100italic%2C200italic%2C300italic%2Citalic%2C500italic%2C600italic%2C700italic%2C800italic%2C900italic%7CAmiri%3Aregular%2Citalic%2C700%2C700italic%7CAllison%3Aregular&subset=cyrillic%2Clatin%2Clatin-ext%2Carabic%2Cvietnamese&ver=6.0.1',
  'https://fonts.googleapis.com/css?family=Oswald%3A200%2C300%2Cregular%2C500%2C600%2C700%7CMerriweather%3A300%2C300italic%2Cregular%2Citalic%2C700%2C700italic%2C900%2C900italic%7CJost%3A100%2C200%2C300%2Cregular%2C500%2C600%2C700%2C800%2C900%2C100italic%2C200italic%2C300italic%2Citalic%2C500italic%2C600italic%2C700italic%2C800italic%2C900italic%7CMontserrat%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2Cregular%2Citalic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CAllison%3Aregular&subset=cyrillic%2Ccyrillic-ext%2Clatin%2Clatin-ext%2Cvietnamese&ver=6.0.1',
  'https://fonts.googleapis.com/css2?family=Boogaloo&family=Lato:wght@100;300;400;900&display=swap',
  'https://fonts.googleapis.com/css2?family=Handlee&family=Neucha&family=Pacifico&family=Patrick+Hand&family=Patrick+Hand+SC&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Sacramento&display=swap',
  'https://fonts.googleapis.com/css2?family=Yellowtail&display=swap',
  '/pettipetti/css/bootstrap.min.css',
  '/bbmirissa/css/style.css',
  '/pettipetti/css/secondary/style.css',
  '/pettipetti/css/vendors.min.css',
  '/pettipetti/css/custom.css',
];

const normalizeHotelName = (value = '') =>
  String(value)
    .toLowerCase()
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const formatOfferDate = (value) => {
  if (!value) return '';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

const Offers = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const loadOffers = async () => {
      try {
        const response = await fetch(OFFERS_API);
        if (!response.ok) {
          throw new Error('Failed to load offers');
        }

        const data = await response.json();
        const items = Array.isArray(data) ? data : data?.offers || data?.data || [];
        const filtered = items.filter((offer) => {
          const hotelMatch =
            normalizeHotelName(offer.hotelName) === normalizeHotelName(TARGET_HOTEL);
          const statusMatch = String(offer.status || '').toLowerCase() === 'active';
          return hotelMatch && statusMatch;
        });

        if (!cancelled) {
          setOffers(filtered);
        }
      } catch {
        if (!cancelled) {
          setOffers([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadOffers();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      {stylesheets.map((href, index) => (
        <link key={index} rel="stylesheet" href={href} type="text/css" media="all" />
      ))}
      <title>Offers | Banana Bunks Mirissa | Oryza Leisure</title>
      <div
        className="home page-template-default page page-id-15043 theme-hotale gdlr-core-body tourmaster-body woocommerce-no-js hotale-body hotale-body-front hotale-full hotale-with-sticky-navigation hotale-blockquote-style-3 gdlr-core-link-to-lightbox"
        data-home-url=""
      >
        <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Yellowtail&display=swap');

          .hotale-page-title hotale-additional-font {
            font-family: 'Yellowtail', cursive !important;
            font-style: normal !important;
            font-weight: 400 !important;
            color: rgb(255, 255, 255) !important;
            font-size: 80px !important;
            line-height: 96px !important;
          }

          @media (max-width: 375px) {
            .hotale-page-title hotale-additional-font {
              font-size: 35px !important;
              line-height: 56px !important;
            }
          }

          .bb-offers-status {
            font-size: 30px;
            text-align: center;
            font-weight: 700;
            letter-spacing: 0px;
            color: #ffffff;
            padding: 40px 16px 80px;
          }

          .bb-offers-grid {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 28px;
            padding: 20px 10px 80px;
            align-items: stretch;
          }

          .bb-offer-card {
            background: #ffffff;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
            display: flex;
            flex-direction: column;
            height: 100%;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .bb-offer-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 16px 32px rgba(0, 0, 0, 0.22);
          }

          .bb-offer-card__media {
            position: relative;
            width: 100%;
            height: 220px;
            background: linear-gradient(135deg, #585550 0%, #3a4a26 100%);
            overflow: hidden;
          }

          .bb-offer-card__image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
          }

          .bb-offer-card__badge {
            position: absolute;
            top: 14px;
            left: 14px;
            background: #eeb85e;
            color: #3a4a26;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 1px;
            text-transform: uppercase;
            padding: 6px 12px;
            border-radius: 999px;
          }

          .bb-offer-card__body {
            padding: 22px 22px 24px;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            background: #f9f9f9;
          }

          .bb-offer-card__title {
            font-family: 'Poppins', sans-serif;
            font-size: 22px;
            font-weight: 600;
            color: #585550;
            margin: 0 0 10px;
            line-height: 1.3;
          }

          .bb-offer-card__desc {
            color: #666;
            font-size: 15px;
            line-height: 1.6;
            margin: 0 0 16px;
            flex-grow: 1;
          }

          .bb-offer-card__meta {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            flex-wrap: wrap;
            margin-top: auto;
          }

          .bb-offer-card__date {
            color: #eeb85e;
            font-size: 13px;
            font-weight: 600;
            letter-spacing: 0.4px;
            text-transform: uppercase;
          }

          .bb-offer-card__price {
            color: #3a4a26;
            font-size: 16px;
            font-weight: 700;
          }

          .bb-offer-card__cta {
            display: inline-flex;
            align-items: center;
            margin-top: 16px;
            color: #585550;
            font-size: 13px;
            font-weight: 600;
            letter-spacing: 1.5px;
            text-transform: uppercase;
            text-decoration: none;
            transition: color 0.2s ease;
          }

          .bb-offer-card__cta:hover {
            color: #eeb85e;
          }

          @media (max-width: 992px) {
            .bb-offers-grid {
              grid-template-columns: repeat(2, minmax(0, 1fr));
              gap: 22px;
            }
          }

          @media (max-width: 640px) {
            .bb-offers-grid {
              grid-template-columns: 1fr;
              gap: 18px;
              padding: 10px 0 60px;
            }

            .bb-offer-card__media {
              height: 200px;
            }

            .bb-offer-card__title {
              font-size: 20px;
            }

            .bb-offers-status {
            color: #ffffff;
              font-size: 22px;
              padding: 24px 12px 60px;
            }
          }
        `}
      </style>
        <Navbar />
        <div className="hotale-page-title-wrap hotale-style-custom hotale-center-align">
          <div className="hotale-header-transparent-substitute"></div>
          <div className="hotale-page-title-overlay"></div>
          <div className="hotale-page-title-container hotale-container">
            <div className="hotale-page-title-content hotale-item-pdlr">
              <h1 className="hotale-page-title hotale-additional-font">
                <b>Offers</b>
              </h1>
            </div>
          </div>
        </div>
        
        <div className="hotale-page-wrapper bbmirissabg" id="hotale-page-wrapper">
          <div className="gdlr-core-page-builder-body">
            <div className="gdlr-core-pbf-section">
              <div className="gdlr-core-pbf-section-container gdlr-core-container clearfix">
                <div className="gdlr-core-pbf-element">
                  <div className="gdlr-core-blog-item gdlr-core-item-pdb clearfix gdlr-core-style-blog-column gdlr-core-left-align" style={{ paddingBottom: '40px' }}>
                    <div className="gdlr-core-blog-item-holder gdlr-core-js-2 clearfix" data-layout="fitrows">
                      {loading ? (
                        <h3 className="bb-offers-status">Loading offers...</h3>
                      ) : offers.length === 0 ? (
                        <h3 className="bb-offers-status">
                          There are no offers at the moment!
                        </h3>
                      ) : (
                        <div className="bb-offers-grid">
                          {offers.map((offer) => {
                            const offerLink = offer.link || offer.url || offer.bookingUrl;
                            const offerPrice = offer.price || offer.discount;

                            return (
                              <article className="bb-offer-card" key={offer._id || offer.title}>
                                <div className="bb-offer-card__media">
                                  {offer.image ? (
                                    <img
                                      className="bb-offer-card__image"
                                      src={offer.image}
                                      alt={offer.title || 'Hotel offer'}
                                    />
                                  ) : null}
                                  <span className="bb-offer-card__badge">Offer</span>
                                </div>
                                <div className="bb-offer-card__body">
                                  <h3 className="bb-offer-card__title">{offer.title}</h3>
                                  {offer.description ? (
                                    <p className="bb-offer-card__desc">{offer.description}</p>
                                  ) : null}
                                  <div className="bb-offer-card__meta">
                                    {offer.date ? (
                                      <span className="bb-offer-card__date">
                                        Valid until {formatOfferDate(offer.date)}
                                      </span>
                                    ) : null}
                                    {offerPrice ? (
                                      <span className="bb-offer-card__price">{offerPrice}</span>
                                    ) : null}
                                  </div>
                                  {offerLink ? (
                                    <a className="bb-offer-card__cta" href={offerLink}>
                                      View offer
                                    </a>
                                  ) : null}
                                </div>
                              </article>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <Footer />
      </div>
    </>
  );
};

export default Offers;
